import classNames from 'classnames';

import { UserInfo } from '@Comments/components/Header/UserInfo';
import { useAppContext } from '@Comments/context/AppContext';
import { Comments } from '@Comments/components/Comments/Comments';
import { ReplyForm } from '@Comments/components/ReplyForm/ReplyForm';
import { Tabs } from '@Comments/components/Tabs/Tabs';

import './Content.scss';

export const Content = () => {
  const { thread, layout, commentsCount, env, user, activeReplyForm } =
    useAppContext();

  const hasCommentsOrMessage =
    commentsCount > 0 ||
    thread.welcomeMessage !== '' ||
    thread.goodbyeMessage !== '';

  return (
    <div
      className={classNames('srf-comments-content-wrapper', {
        'srf-comments-content-wrapper--expanded': layout.isExpanded,
      })}>
      <div className="srf-comments-header-content-wrapper">
        {thread.state === 'open' && (
          <>
            <UserInfo />
            <ReplyForm
              threadUrn={env.threadUrn}
              isUserLoggedIn={user.isLoggedIn}
              isSrgLoginSupported={env.isSrgLoginSupported}
              activeReplyForm={activeReplyForm}
            />
          </>
        )}
        <Tabs />
      </div>
      {hasCommentsOrMessage && <Comments />}
      {!hasCommentsOrMessage && (
        <p className="srf-comments-message">
          Es wurden noch keine Kommentare erfasst. Schreiben Sie den ersten
          Kommentar.
        </p>
      )}
    </div>
  );
};
